const particlesContainer = document.getElementById('particlesContainer');
const flavorCards = document.querySelectorAll('.flavor-card');

function createParticles(x, y, count = 5, color) {
    for (let i = 0; i < count; i++) {
        const particle = document.createElement('div');
        particle.className = 'particle';
        particle.style.left = x + 'px';
        particle.style.top = y + 'px';
        particle.style.opacity = '1';
        particle.style.background = color
        particlesContainer.appendChild(particle);

        const angle = (Math.PI * 2 * i) / count + (Math.random() - 0.5) * 0.5;
        const velocity = 60 + Math.random() * 40;
        const endX = x + Math.cos(angle) * velocity;
        const endY = y + Math.sin(angle) * velocity;

        let startTime = null;
        const duration = 600 + Math.random() * 400;

        function animate(timestamp) {
            if (!startTime) startTime = timestamp;
            const elapsed = timestamp - startTime;
            const progress = Math.min(elapsed / duration, 1);

            const easeProgress = 1 - Math.pow(1 - progress, 3);

            const currentX = x + (endX - x) * easeProgress;
            const currentY = y + (endY - y) * easeProgress;
            const currentOpacity = 1 - progress;

            particle.style.left = currentX + 'px';
            particle.style.top = currentY + 'px';
            particle.style.opacity = currentOpacity;

            if (progress < 1) {
                requestAnimationFrame(animate);
            } else {
                particle.remove();
            }
        }

        requestAnimationFrame(animate);
    }
}

// Event listeners
flavorCards.forEach((card,i) => {
    card.addEventListener('mouseenter', (e) => {
        const rect = card.getBoundingClientRect();
        const containerRect = particlesContainer.getBoundingClientRect();

        const x = rect.left - containerRect.left + rect.width / 2;
        const y = rect.top - containerRect.top + rect.height / 2;

        createParticles(x, y, 8, card.dataset.bgcolor);
        const currentCardPosition = (flavorCards[i+1] || card).dataset.position
        handleProgressFill(card, currentCardPosition, i)
    });
});

function handleProgressFill(card, position, index){
    const progressFill = document.querySelector('.progress-fill');
    const progressFillMobile = document.querySelector('.progress-fill-mobile');
    const currentPosition= flavorCards.length === index+1  ? 100 : Number(position);

    progressFill.style.width = `${currentPosition}%`;
    progressFill.style.background = card.dataset.bgcolor;

    progressFillMobile.style.height = `${currentPosition}%`;
    progressFillMobile.style.background = card.dataset.bgcolor;
  }